export enum RuleChangeDataType {
    Double = 0,
}
